import { Injectable, signal } from '@angular/core';
import { getCookie, setCookie } from 'src/app/core/cookie-utils';

type Alias = string | undefined;

@Injectable({
  providedIn: 'root',
})
export class AliasService {
  readonly #alias = signal<Alias>(getCookie('trimalias'));
  readonly alias = this.#alias.asReadonly();

  setAlias(nextAlias: Alias, isTenantAdmin: boolean) {
    // ensure distinct values, and write cookie as side effect
    if (nextAlias !== this.#alias()) {
      setCookieAlias(nextAlias, isTenantAdmin);
      this.#alias.set(nextAlias);
    }
  }
}

function setCookieAlias(userName: Alias, isTenantAdmin: boolean) {
  setCookie('trimalias', userName ?? '');
  setCookie('tenantadmin', isTenantAdmin ? 'true' : 'false');
}
